export default __webpack_public_path__ + "static/media/caveTubing3.a45ab81c.webp";